import React from 'react'
import PropTypes from 'prop-types'
import { t } from 'i18next'
import './PaymentMethodSection.css'

function PaymentMethodSection({ onOpenModal, selectedMethod }) {
  return (
    <div
      className="payment-method-section"
      data-testid="container-payment-method-section">
      <p className="payment-method-section__title">
        {t('PAYMENT_METHOD_SECTION_T.TITLE')}
      </p>
      {selectedMethod && (
        <p
          className="payment-method-section__selected"
          data-testid="text-selected-payment-method">
          {t(selectedMethod.label)}
        </p>
      )}
      <button
        type="button"
        onClick={onOpenModal}
        className="payment-method-section__btn"
        data-testid="btn-open-payment-method-modal">
        {t('PAYMENT_METHOD_SECTION_T.SELECT_BUTTON')}
      </button>
    </div>
  )
}

PaymentMethodSection.propTypes = {
  onOpenModal: PropTypes.func.isRequired,
  selectedMethod: PropTypes.shape({
    label: PropTypes.string.isRequired,
  }),
}

export default PaymentMethodSection
